import React from 'react'

import {
  useLocation, useNavigate, useNavigationType, useParams,
} from 'react-router-dom'

// Compatibility shim: react-router-dom v6 removed the `withRouter` HOC that v5
// provided. Class components in this codebase still rely on receiving `match`,
// `location`, and `history` as props, so this HOC reconstructs the v5-shaped
// props from v6 hooks. Prefer hooks directly in new/function components.
export default function withRouter(Component) {
  function WithRouter(props) {
    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()
    const navigationType = useNavigationType()
    const match = { params }
    const history = {
      action: navigationType,
      push: (to, state) => navigate(to, state ? { state } : undefined),
      replace: (to, state) => navigate(to, state ? { replace: true, state } : { replace: true }),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
    }

    return (
      <Component
        {...props}
        match={match}
        location={location}
        history={history}
        navigate={navigate}
        params={params}
      />
    )
  }

  WithRouter.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`
  return WithRouter
}
